import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Salesunit } from './salesunit.model';
import { SalesunitService } from './salesunit.service';

@Component({
    selector: 'jhi-salesunit-detail',
    templateUrl: './salesunit-detail.component.html'
})
export class SalesunitDetailComponent implements OnInit, OnDestroy {

    salesunit: Salesunit;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private salesunitService: SalesunitService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['salesunit']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInSalesunits();
    }

    load(id) {
        this.salesunitService.find(id).subscribe((salesunit) => {
            this.salesunit = salesunit;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInSalesunits() {
        this.eventSubscriber = this.eventManager.subscribe('salesunitListModification', (response) => this.load(this.salesunit.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit-detail.component.ts